import { Box, Divider as MuiDivider, styled, Typography } from '@mui/material';

export const AlertContainer = styled(Box)`
  position: absolute;
  bottom: 0;
  right: 0;
  width: 34rem;
`;

export const SubHeaderText = styled(Typography)(
  ({ theme }) => `
    font-size: 16px;
    font-weight: 300;
    color: '${theme.palette.brand.black}';
    margin-top: 10px;
  `,
);

export const SubHeader = styled(Typography)`
  font-size: 16px;
  font-weight: 400;
`;

export const Divider = styled(MuiDivider)`
  margin: 10px 0;
`;

export const Container = styled(Box)`
  max-height: 30vh;
  overflow-x: scroll;
`;
export const BoxContainer = styled(Box)`
  position: relative;
  height: 95%;
`;
